<div class="settings-map-wrapper d-flex flex-column">

  @if (isMapConsentGiven) {
    <div id="mapSettings" class="avs-map"></div>
  }
  @else {
    <avs-map-consent></avs-map-consent>
  }
</div>
